import React from "react";
import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const members = [
    ["Dr. Vinay Agrawal", "Chairman", "Chancellor ISBM University"],
    ["Prof.(Dr) Anand Mahalwar", "Member", "Vice Chancellor ISBM University"],
    [
        "Mrs. Pramila Mahesh Agrawal",
        "Member",
        "Nominee, Sponsoring Body, ISBM University",
    ],
    [
        "Shri Mahesh Ratanlal Agrawal",
        "Member",
        "Nominee, Sponsoring Body, ISBM University",
    ],
    [
        "Shri Yashwanth Raj Parasmal",
        "Member",
        "Nominee, Sponsoring Body, ISBM University",
    ],
    ["Dr. Sarita Sinha", "Member", "Nominee & Representative of State Govt."],
    [
        "Dr. Madan Lal Lakhanpal",
        "Member",
        "Nominee & Representative of State Govt.",
    ],
    ["Dr. Sheela Tiwari", "Member", "Nominee & Representative of State Govt."],
    ["Dr. Barada Prasad Bhol", "Member Secretary", "Registrar, ISBM University"],
];
const functions = [
    "Review, suggest and approve policies, plans, procedures and measures for the University's development.",
    "Make recommendations to the Chancellor/Sponsoring Body regarding different strategies.",
    "Recommend creation of new officers, teachers and staff of the University.",
    "Consider and approve recommendations made by the Board of Management, Academic Council, Chancellor and Vice Chancellor.",
    "Meet at least three times in a calendar year.",
    "Maintain a quorum of five members as per section 22(5) of the Act.",
];
export default function GoverningBody() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />
            <main>
                <section className="bg-navy pb-[150px] pt-[150px] text-white">
                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                        <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[.18em] text-gold">
                            <span className="h-px w-12 bg-current" />
                            Statutory Governance
                        </div>
                        <h1 className="mt-7 font-serif text-[clamp(50px,6.5vw,92px)] leading-[.96]">
                            Governing Body
                            <span className="block text-gold">of ISBM University.</span>
                        </h1>
                        <p className="mt-8 max-w-3xl text-lg leading-8 text-white/65">
                            The Governing Body is the principal decision-making body of the
                            University. It has the power and responsibility to develop
                            strategic plans for the deployment of resources to ensure academic
                            excellence.
                        </p>
                    </div>
                </section>
                <section className="bg-white py-20 lg:py-28">
                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.75fr_1.25fr]">
                        <div>
                            <Eyebrow>Powers & Functions</Eyebrow>
                            <Title
                                before="Strategic"
                                highlight="Responsibility"
                                after="At The Highest Level"
                                position="middle"
                                theme="burgundy"
                            />
                        </div>
                        <div className="border-t border-navy/15">
                            {functions.map((x, i) => (
                                <div key={x} className="grid grid-cols-[55px_1fr] gap-5 border-b border-navy/15 py-4">
                                    <span className="font-serif text-2xl text-gold-dark">
                                        0{i + 1}
                                    </span>
                                    <p className="leading-7 text-ink/65">{x}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <section className="bg-ivory py-20 lg:py-28">
                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                        <Eyebrow>Committee Composition</Eyebrow>
                        <Title
                            before="Members Of The"
                            highlight="Governing Body"
                            after=""
                            position="middle"
                            theme="burgundy"
                        />
                        <div className="mt-12 overflow-hidden border border-navy/10 bg-white">
                            {members.map(([n, d, r], i) => (
                                <div
                                    key={n}
                                    className="grid gap-4 border-b border-navy/10 px-7 py-6 last:border-0 md:grid-cols-[55px_1fr_180px_1.2fr]"
                                >
                                    <span className="text-gold-dark">0{i + 1}</span>
                                    <strong className="font-serif text-xl font-normal text-navy">
                                        {n}
                                    </strong>
                                    <span className="text-xs font-bold uppercase tracking-[.1em] text-burgundy">
                                        {d}
                                    </span>
                                    <span className="text-sm text-ink/55">{r}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
